module.exports = __webpack_public_path__ + "mini peko.gif?1a48693700d2a3431e3942b2ee17f33b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mini peko.gif
// module id = 138
// module chunks = 0